import React from "react";
import Modal from "./Modal";
import Button from "@components/common/Button/Button";
import { LibraryAddCheckRounded } from "@mui/icons-material";

interface ConfirmationModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title: string;
	description: string;
	confirmText?: string;
	cancelText?: string;
	icon?: React.ReactNode;
	loading?: boolean;
	width?: string;
	padding?: string;
	iconWrapperClassName?: string;
	descriptionClassName?: string;
	buttonClassName?: string;
	confirmButtonClassName?: string;
	cancelButtonClassName?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	title,
	description,
	confirmText = "Yes",
	cancelText = "No",
	icon,
	loading = false,
	width = "max-w-md",
	padding = "p-8",
	iconWrapperClassName = "flex justify-center mb-6",
	descriptionClassName = "text-gray-600 mb-8",
	buttonClassName = "flex-1 py-3",
	confirmButtonClassName,
	cancelButtonClassName,
}) => {
	const cancelClass = cancelButtonClassName ?? `${buttonClassName} border-2 border-accent text-accent hover:bg-accent-40`;
	const confirmClass = confirmButtonClassName ?? buttonClassName;
	const defaultIcon = (
		<div className="relative">
			<LibraryAddCheckRounded fontSize="large" className="text-accent" />
		</div>
	);

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			showCloseIcon={false}
			width={width}
			padding={padding}
			className="text-center">
			<div className={iconWrapperClassName + " mt-6"}>{icon || defaultIcon}</div>
			<h2 className="text-xl font-bold text-gray-900 mb-3">{title}</h2>
			<p className={descriptionClassName}>{description}</p>
			<div className="flex space-x-4">
				<Button
					text={cancelText}
					variant="tertiary"
					onClick={onClose}
					className={cancelClass}
					disabled={loading}
				/>
				<Button
					text={confirmText}
					variant="primary"
					onClick={onConfirm}
					className={confirmClass}
					loading={loading}
				/>
			</div>
		</Modal>
	);
};

export default ConfirmationModal;
